import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AccountService } from '@app/core/services';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { IconComponent } from '@shared/icon/icon.component';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { first, takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-new-subject-banner',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, LazyLoadImageModule, RouterModule, IconComponent],
  templateUrl: './new-subject-banner.component.html',
  styleUrls: ['./new-subject-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewSubjectBannerComponent extends AbstractPane {
  private readonly accountService = inject(AccountService);

  public thesisList: string[] = [
    'ad.ad-create-content.thesis1',
    'ad.ad-create-content.thesis2',
    'ad.ad-create-content.thesis3',
  ];

  protected router = inject(Router);

  hasContent(): boolean {
    return !!this._pane;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  // Почему помечать человека как преподавателя а не просто перекируть его в конструктор?
  public newLesson() {
    this.accountService
      .markAsTeacher()
      .pipe(first())
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (account) => {
          this.contextService.updateMe(account);
          this.router.navigateByUrl('/constructor').then(() => true);
        },
        error: (error: any) => {
          this.router.navigateByUrl('/constructor').then(() => true);
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public trackByFn(index) {
    return index;
  }
}
